<template>
  <div class="container" id="goods-edit">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <el-form :inline="true" label-width="" size="small">
        <el-form-item label="模板名称">
          <el-input
            v-model="searchForm.name"
            placeholder="请输入模板名称"
            clearable
            :maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            @click="getList()"
            v-on:keyup.enter="getList()"
            type="primary"
            >查询</el-button
          >
          <el-button plain @click="reset()" type="primary">重置</el-button>
        </el-form-item>
      </el-form>

      <div style="padding-bottom: 20px">
        <el-card
          style="margin-bottom: 20px; box-shadow: none"
          class="box-card"
          v-for="(item, index) in tableData"
          :key="index"
        >
          <div
            slot="header"
            style="
              display: flex;

              justify-content: space-between;
            "
          >
            <div class="title">{{ item.name }}</div>
            <div>
              <el-button type="text" @click="add(item.id)">查看</el-button>
            </div>
          </div>
          <div>
            <el-table
              :data="item.list"
              style="width: 100%"
              :header-cell-style="{
                textAlign: 'left',
                background: '#F5F6FA',
                color: '#303033',
              }"
              :row-style="{ height: '70px', textAlign: 'left' }"
            >
              <el-table-column prop="date" label="运送方式">
                <template slot="header">
                  <div style="text-align: left; margin-left: 36px">
                    运送方式
                  </div>
                </template>
                <template>
                  <div style="text-align: left; margin-left: 36px">快递</div>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="运送到">
                <template slot="header">
                  <div style="text-align: left">运送到</div>
                </template>
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.address == '全部地区'"
                    style="text-align: left"
                  >
                    全部地区
                  </div>
                  <div v-else>
                    <el-tooltip
                      popper-class="atooltip"
                      effect="dark"
                      :content="scope.row.address"
                      placement="bottom-start"
                    >
                      <div style="text-align: left; width: 150px">
                        地区（查看区域）
                      </div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="firstNum">
                <template slot="header">
                  <div
                    v-if="item.list && item.list[0].calculType == 2"
                    style="text-align: left"
                  >
                    首重（KG）
                  </div>
                  <div v-else style="text-align: left">首件（个）</div>
                </template>
                <template slot-scope="scope">
                  <div style="text-align: left">{{ scope.row.firstNum }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="freight" label="运费（元）">
                <template slot="header">
                  <div style="text-align: left">运费（元）</div>
                </template>
                <template slot-scope="scope">
                  <div style="text-align: left">{{ scope.row.freight }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="addNum" label="续件（个）">
                <template slot="header">
                  <div
                    v-if="item.list && item.list[0].calculType == 2"
                    style="text-align: left"
                  >
                    续重（KG）
                  </div>
                  <div v-else style="text-align: left">续件（个）</div>
                </template>
                <template slot-scope="scope">
                  <div style="text-align: left">{{ scope.row.addNum }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="addPrice" label="运费（元）">
                <template slot="header">
                  <div style="text-align: left">运费（元）</div>
                </template>
                <template slot-scope="scope">
                  <div style="text-align: left">{{ scope.row.addPrice }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch
  },
  data () {
    return {
      searchList: {
        list: [
          { title: '运费模板', path: '', type: '0' }
        ]
      },
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '运费模板', path: '', type: '1' }
        ]
      },
      name: '---',
      dialogUser: false,
      models: [{}, {}],
      searchForm: {
        name: '',
        pageNo: 1,
        pageSize: 1000
      },
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    reset () {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 1000
      this.searchForm.name = ''
      this.getList()
    },
    getList () {
      this.axios.post('/goods/shippingPageList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.tableData = res.data.list
          }
        })
    },
    add (id) {
      this.$router.push({
        name: 'transportationModelEdit',
        query: {
          id: id
        }
      })
    }
  }
}
</script>
<style>
/* 改变三角形颜色 */
/* 朝上 */
.atooltip[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #ffffff;
}
/* 朝下 */
.atooltip[x-placement^="top"] .popper__arrow:after {
  border-top-color: #ffffff;
}
/* 改变三角形外边框 */
/* 三角形朝下的时候 */
.atooltip[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ffffff !important;
}
/* 三角形朝上的时候 */
.atooltip[x-placement^="top"] .popper__arrow {
  border-top-color: #ffffff !important;
}
/* 自定义内容的区域的颜色 */
.atooltip {
  width: 319px;
  height: auto;
  background: #ffffff !important;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: none;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033 !important;
}
.el-card__body {
  padding: 0px !important;
}
</style>
<style scoped lang="scss">
::v-deep .el-card__header {
  padding: 0px 0px;
  height: 48px;
  line-height: 48px;
  background: #f5f6fa;
  opacity: 1;
  border-radius: 0px;
  padding-left: 18px;
  padding-right: 18px;
}
.title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #303033;
  opacity: 1;
}
</style>

